import { requiredField } from '@common/utils';

export const distanceValidator = (start: string, end: string): string | void => {
  if (parseFloat(start) > parseFloat(end)) {
    return 'Start should be less';
  }
};

export const odometerValidator = (
  value: unknown,
  { odometerStart }: Record<string, unknown>,
): string | void =>
  requiredField(value) ||
  distanceValidator((odometerStart as string)?.toString() || '', value as string);
